import { render, staticRenderFns } from "./AddRelatedMovementsViewer.vue?vue&type=template&id=3b3077f6&scoped=true&"
import script from "./AddRelatedMovementsViewer.vue?vue&type=script&lang=js&"
export * from "./AddRelatedMovementsViewer.vue?vue&type=script&lang=js&"
import style0 from "./AddRelatedMovementsViewer.vue?vue&type=style&index=0&id=3b3077f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3077f6",
  null
  
)

export default component.exports